import { FC, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import PartnerUpload from "../modules/apps/academies-partners/partnersModal";

const PrivateRoutes = () => {
  const UserPage = lazy(() => import("../modules/apps/users/UserPage"));
  const NewsLetterPage = lazy(() => import("../modules/apps/news-letters/NewsLetterPage"));
  const SubscriptionPage = lazy(() => import("../modules/apps/subscriptions/SubscriptionPage"));
  const PlanPage = lazy(() => import("../modules/apps/plans/PlanPage"));
  const ContactPage = lazy(() => import("../modules/apps/contacts/ContactPage"));
  const VideoPage = lazy(() => import("../modules/apps/videos/VideosPage"));
  const SettingsPage = lazy(() => import("../modules/apps/settings/SettingsPage"));
  const DashboardPage = lazy(() => import("../modules/apps/dashboard/DashboardPage"));
  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path="auth/*" element={<Navigate to="/dashboard" />} />
          <Route
            path="users/*"
            element={
              <SuspensedView>
                <UserPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/users/list" />} />

          <Route
            path="news-letters/*"
            element={
              <SuspensedView>
                <NewsLetterPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/news-letters/list" />} />

          <Route 
           path= "academies-partners/*"
           element= {
            <SuspensedView>
                <PartnerUpload />
              </SuspensedView>
           }
           />

          <Route
            path="subscriptions/*"
            element={
              <SuspensedView>
                <SubscriptionPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/subscriptions/list" />} />

          <Route
            path="plans/*"
            element={
              <SuspensedView>
                <PlanPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/plans/list" />} />

          <Route
            path="contacts/*"
            element={
              <SuspensedView>
                <ContactPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/contacts/list" />} />

          <Route
            path="videos/*"
            element={
              <SuspensedView>
                <VideoPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/videos/list" />} />
          <Route
            path="settings/*"
            element={
              <SuspensedView>
                <SettingsPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/settings/list" />} />

          <Route
            path="dashboard/*"
            element={
              <SuspensedView>
                <DashboardPage />
              </SuspensedView>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard/detail" />} />

        </Route>
      </Routes>
    </>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
